import axios from 'axios';
import type { HeadersDefaults } from 'axios';
import { API_URL } from '@/configs';

const http = axios.create({
  baseURL: API_URL,
});

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status: number | undefined = error?.response?.status;

    // For 401 Unauthorized, preserve the original Axios error so that
    // catch blocks can inspect error.response.status and react accordingly
    // (e.g. clearing stale auth state in FieldPage/auth flow).
    if (status === 401) {
      return Promise.reject(error);
    }

    // For all other errors, extract the payload from the response body
    // for ergonomic error handling (errors/message object).
    const errorData = error?.response?.data;

    if (typeof errorData === 'object' && errorData !== null) {
      return Promise.reject(errorData);
    }

    const errMessage: string = errorData || 'Unknown Error';
    return Promise.reject(errMessage);
  },
);

const setHTTPHeader = (header: HeadersDefaults['common']) => {
  http.defaults.headers.common = { ...http.defaults.headers.common, ...header };
};

export { http, setHTTPHeader };
